import { useEffect, useState } from "react";

import type { PhotoType } from "@/components/photos-list";
import { Dialog, DialogContent } from "@/components/ui/dialog";

import Gallery from "./gallery";
import Photo from "./photo";

interface GalleryThumbnailsModalProps
  extends React.ComponentProps<typeof Dialog> {
  photo?: number;
  photos: PhotoType[];
}

export default function GalleryThumbnailsModal({
  photo,
  photos,
  ...props
}: GalleryThumbnailsModalProps) {
  const [photoIndex, setPhotoIndex] = useState(photo ?? -1);

  const handleChange = (index: number) => setPhotoIndex(index);

  useEffect(() => {
    setPhotoIndex(photo ?? -1);
  }, [photo]);

  return (
    <Dialog {...props}>
      <DialogContent
        className="flex min-h-full flex-col gap-0 bg-black md:max-w-none"
        overlayClassName="bg-black items-start md:py-0"
      >
        {photoIndex === -1 ? (
          <Gallery
            onClick={handleChange}
            onClose={() => props.onOpenChange?.(false)}
            photos={photos}
          />
        ) : (
          <Photo
            onChange={handleChange}
            onClose={() => props.onOpenChange?.(false)}
            photo={photoIndex}
            photos={photos}
          />
        )}
      </DialogContent>
    </Dialog>
  );
}
